import { Controller } from "@hotwired/stimulus"
import { put } from '@rails/request.js'

// Connects to data-controller="checkbox-submit"
export default class extends Controller {
  submit() {
    let url = this.element.dataset.updateUrl;

    let status = this.element.checked ? 'complete' : 'incomplete';

    console.log(this.element)

    put(url, { body: { checklist_item: { status } }, responseKind: 'turbo-stream' });
  }
}
